import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import storeBuilder from 'reduxStore/store';
import { PaymentMessage } from './index';
import { requestBankDetailsAction, requestLastPaymentStatus } from './actions';

const store = storeBuilder();

function render(
  {
    closingBalance,
    supplierId,
    reFetchRemittances,
    paymentDueDays,
    paymentReference,
    paymentId,
    autoOpenPaymentForm,
    hasDirectDebitEnabled,
  },
  node,
) {
  store.dispatch(requestBankDetailsAction(supplierId));
  store.dispatch(requestLastPaymentStatus(supplierId));
  ReactDOM.render(
    <Provider store={store}>
      <PaymentMessage
        closingBalance={closingBalance}
        supplierId={supplierId}
        reFetchRemittances={reFetchRemittances}
        paymentDueDays={paymentDueDays}
        paymentReference={paymentReference}
        paymentId={paymentId}
        autoOpenPaymentForm={autoOpenPaymentForm}
        hasDirectDebitEnabled={hasDirectDebitEnabled}
      />
    </Provider>,
    node,
  );
}

function destroy(target) {
  ReactDOM.unmountComponentAtNode(target);
}

export const paymentsInitializer = {
  render,
  destroy,
};
